export interface DiagnosticSnapshot {
  previousRoute: string | null;
  consoleErrors: string[];
}

let _previousRoute: string | null = null;
const _errors: string[] = [];
const MAX_ERRORS = 20;

function pushError(msg: string) {
  if (_errors.length >= MAX_ERRORS) _errors.shift();
  _errors.push(msg);
}

export function setPreviousRoute(route: string) {
  if (!route.startsWith('/help')) _previousRoute = route;
}

export function getDiagnosticSnapshot(): DiagnosticSnapshot {
  return {
    previousRoute: _previousRoute,
    consoleErrors: [..._errors],
  };
}

// Initialise error capture — called once at app startup
const _origConsoleError = console.error;
console.error = (...args: unknown[]) => {
  pushError(String(args[0]));
  _origConsoleError(...args);
};

if (typeof window !== 'undefined') {
  window.addEventListener('unhandledrejection', (e) => {
    const msg = e.reason instanceof Error ? e.reason.message : String(e.reason);
    pushError(msg);
  });
}
